import React, { useEffect, useState, useRef } from 'react'

const TimeTriggerDropdown = props => {
  const [showTrigger, setShowTrigger] = useState(false)
  const [period, setPeriod] = useState(0)
  const [periodMinutes, setPeriodMinutes] = useState(0)
  const [triggerType, setTriggerType] = useState('before')
  const triggerRef = useRef()

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (triggerRef.current && !triggerRef.current.contains(event.target)) setShowTrigger(false)
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [triggerRef])

  useEffect(() => {
    setValues()
  }, [])

  useEffect(() => {
    setValues(props.message ? props.message : null)
  }, [props.message])

  const setValues = (message = null) => {
    if (message) {
      const hours = Math.floor(message.trigger_period / 60)
      setPeriod(hours)
      setPeriodMinutes(message.trigger_period - hours * 60)
      setTriggerType(message.trigger_type || 'before')
    } else {
      setPeriod(0)
      setPeriodMinutes(0)
      setTriggerType('before')
    }
  }

  const onPeriodChange = value => {
    if (value >= 0) {
      const minutes = (periodMinutes || 0) + value * 60

      setPeriod(value)
      props.onTriggerChange({trigger_period: minutes, trigger_type: triggerType})
    }
  }

  const onPeriodMinutesChange = value => {
    if (value >= 0 && value % 15 == 0) {
      const minutes = parseInt(value) + period * 60

      setPeriodMinutes(value)
      props.onTriggerChange({trigger_type: triggerType, trigger_period: minutes})
    }
  }

  const onTriggerTypeChange = value => {
    setTriggerType(value)
    props.onTriggerChange({trigger_type: value, trigger_period: period * 60 + periodMinutes})
  }

  return (
    <div className='time-trigger'>
      <button className='btn btn-default time-trigger-btn' onClick={ () => setShowTrigger(true) }>
        {`${period} h ${periodMinutes} min ${triggerType}`}
        <span className='caret' />
      </button>
      <div id='time-trigger' ref={triggerRef} className={`trigger-content ${showTrigger ? 'open' : '' }`}>
        <div>
          <div className='time-container'>
            <input
              type='number'
              placeholder='hr'
              name='period'
              value={period}
              onChange={e => onPeriodChange(e.target.value)}
            />
            <input
              type='number'
              placeholder='min'
              step={15}
              name='periodMinutes'
              value={periodMinutes}
              onChange={e => onPeriodMinutesChange(e.target.value)}
            />
          </div>
          <div className='trigger-type'>
            <label>
              <input
                checked={triggerType == 'before'}
                onChange={() => onTriggerTypeChange('before')}
                name='type'
                type='radio'
              />
              Before a game
            </label>
            <label>
              <input
                checked={triggerType == 'after'}
                onChange={() => onTriggerTypeChange('after')}
                name='type'
                type='radio'
              />
              After a game
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TimeTriggerDropdown
